import * as yup from "yup";

const profileNameRule = yup
  .string()
  .matches(
    /(^$)|(^[\x20-\x3B\x3D\x3F-\x7D][^&<>~;'"]*$)/,
    "${label} should not contain characters: &, <, >, ~, ;"
  )
  .max(30);

export default yup.object({
  first_name: profileNameRule.clone(),
  last_name: profileNameRule.clone(),
  display_name: yup
    .string()
    .matches(
      /^(?!\\s*$)[^<>~;'"&]+$|^$/,
      "${label} should not contain characters: <, >, ~, ;, ', \", &"
    )
    .max(30),
  email: yup.string().min(1).max(250),
  comment: yup.string().nullable().max(1024),
});
